import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useRevealOnScroll } from "../hooks/useRevealOnScroll";
import { Sparkles, Zap, Layers } from "lucide-react";

const icons = [Sparkles, Zap, Layers];

const About = () => {
  const { t } = useLang();
  const ref = useRevealOnScroll([t]);

  return (
    <section id="about" ref={ref} data-testid="about-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="radial-blob" style={{ width: 500, height: 500, background: "#4361EE", top: "20%", right: "-15%", opacity: 0.25 }} />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal text-[11px] tracking-[0.3em] uppercase font-bold text-[#00F0FF] mb-4">
          {t.about.overline}
        </div>
        <h2 className="reveal font-heading font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight gradient-text max-w-4xl" data-testid="about-title">
          {t.about.title}
        </h2>
        <p className="reveal mt-6 max-w-3xl text-[#9BA1B0] text-base sm:text-lg leading-relaxed font-body">
          {t.about.description}
        </p>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-14">
          {t.about.stats.map((s, i) => (
            <div
              key={i}
              data-testid={`about-stat-${i}`}
              className="reveal glass rounded-2xl p-6 md:p-8"
            >
              <div className="font-heading font-black text-4xl md:text-5xl gradient-cyan tracking-tight">
                {s.value}
              </div>
              <div className="mt-2 text-xs md:text-sm text-[#9BA1B0] font-body tracking-wide">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
          {t.about.cards.map((c, i) => {
            const Icon = icons[i] || Sparkles;
            return (
              <div
                key={i}
                data-testid={`about-card-${i}`}
                className="reveal glass rounded-2xl p-7 md:p-8 hover:border-[#00F0FF]/30 transition-all duration-500 group"
              >
                <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#00F0FF]/20 to-[#0055FF]/20 border border-[#00F0FF]/20 mb-5 group-hover:scale-110 transition-transform">
                  <Icon size={22} className="text-[#00F0FF]" strokeWidth={1.6} />
                </div>
                <h3 className="font-heading font-semibold text-xl text-white mb-2">{c.title}</h3>
                <p className="text-sm text-[#9BA1B0] leading-relaxed font-body">{c.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
